import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconIconists: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="iconists" maskId="round-filled-radius-1-stroke-1.5-IconIconists"><path d="M12 2V22L8 20V4L12 2Z" fill="currentColor"/><path opacity="0.35" d="M16 4V20L12 22V2L16 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconIconists;
